import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { clientService } from '@/services/client-service';
import type { RunningInvocations } from '@/types/core/client';
import type { UUID } from '@/utils/uuid';

import { clientQueryKeys } from './query-keys';

const RUNNING_REFETCH_MS = 30 * 1000;

/**
 * In-flight connector invocations for a tenant. Rows join to agents via
 * claimedBy == clientId, which is how "currently bound workloads" is answered.
 */
export function useRunningInvocations(
  tenantId: UUID | undefined
): UseQueryResult<RunningInvocations, Error> {
  return useQuery<RunningInvocations, Error>({
    queryKey: clientQueryKeys.runningInvocations(tenantId),
    queryFn: () => clientService.listRunningInvocations(tenantId!),
    enabled: !!tenantId,
    refetchInterval: RUNNING_REFETCH_MS,
  });
}
